import TextInput from "../../../../../shared/components/text-input/text-input";

export interface INumberWidget {
  id: string;
  type: "integer" | "float";
  modalType: "datamodelField"
  label: string;
  primaryKey: boolean
  required: boolean;
  readonly: boolean;
}

interface INumberWidgetProps {
  widget: INumberWidget;
  value: string | undefined;
  onChange?(newValue: string, key?: string): void;
}
const NumberWidget = ({widget, value, onChange}: INumberWidgetProps) => {
  const handleNumberChange = (newValue: string) => {
    onChange?.(newValue, widget.id);
  };
  
  return <div className="numberWidget">
    <TextInput 
      label={widget.label} 
      handleOnChange={handleNumberChange} 
      required={widget.required} 
      value={value || ""} 
      controlled={true}
      type="number" 
      id={widget.id} 
      inputKey={widget.id}
      decimalsFormatting={widget.type === "float" ? 4 : undefined}
      onlyWholeNumbers={widget.type === "integer"}
      disabled={widget.readonly}
    />
  </div>;
};

export default NumberWidget;
